import {
	Action,
	AnyAction,
	ThunkAction,
	combineReducers,
	configureStore,
} from '@reduxjs/toolkit';

import handlingListSlice from './slices/handlingListSlice';
import handlingSlice from './slices/handlingSlice';
import tuningShopSlice from './slices/tuningShopSlice';

const reducers = {
	tuningShop: tuningShopSlice,
	handling: handlingSlice,
	handlingList: handlingListSlice,
};

const rootReducer = combineReducers(reducers);

const combinedRootReducer = (
	state: ReturnType<typeof rootReducer> | undefined,
	action: AnyAction,
) => {
	if (action.type === 'resetStore') {
		return rootReducer(undefined, action);
	}
	return rootReducer(state, action);
};

export const store = configureStore({
	reducer: combinedRootReducer,
	devTools: import.meta.env.DEV,
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
	ReturnType,
	RootState,
	unknown,
	Action<string>
>;
